import React from 'react';
import LegalPage from '../components/LegalPage';

export default function Terms() {
  return (
    <LegalPage kicker="Legal" title="Terms of Service" date="Effective date: 20 September 2025">
      <p>
        Welcome to <strong>Zero Immersive Inc</strong> ("we," "our," or "us").
        These Terms of Service ("Terms") govern your use of our games, websites,
        and related services (collectively, the "Services"). By using the
        Services you agree to these Terms — if you don't agree, please stop
        using them.
      </p>
      <p>
        Please also review our <a href="/privacy">Privacy Policy</a>, which
        explains how we handle your data. By accepting these Terms, you also
        accept our Privacy Policy.
      </p>

      <h2>1. License and use</h2>
      <p>We grant you a personal, limited, non-transferable, revocable license to use our Services for entertainment purposes only. You may not:</p>
      <ul>
        <li>Modify, copy, or redistribute our games or content.</li>
        <li>Reverse-engineer, hack, or attempt to bypass security protections.</li>
        <li>Use bots, cheats, or automation tools.</li>
        <li>Exploit bugs or unauthorized methods of gameplay.</li>
      </ul>
      <p>If you break these rules, your license may be revoked immediately.</p>

      <h2>2. Accounts and access</h2>
      <ul>
        <li>Some Services may require an account. You agree to provide accurate information and keep it updated.</li>
        <li>You're responsible for keeping your login details secure.</li>
        <li>Accounts are personal and may not be sold, rented, or transferred.</li>
        <li>You must be at least 16 years old, or have parental/guardian consent, to use our Services.</li>
      </ul>

      <h2>3. Virtual items and purchases</h2>
      <p>Our games may offer virtual currency or virtual items. These are digital features with no real-world value.</p>
      <ul>
        <li>Virtual currency and items can't be exchanged for cash or used outside the Services.</li>
        <li>All purchases are final. Refunds are handled by the app store (Google Play, Apple App Store) according to their policies.</li>
        <li>Subscriptions may automatically renew unless you cancel them in your app store settings.</li>
      </ul>

      <h2>4. User content and conduct</h2>
      <p>You may be able to share content (messages, screenshots, forum posts) within our Services. By doing so, you grant Zero Immersive Inc a worldwide, royalty-free, perpetual license to use, display, and distribute that content.</p>
      <p>You may not post or share:</p>
      <ul>
        <li>Illegal, harmful, abusive, or offensive content.</li>
        <li>Spam, scams, or advertising.</li>
        <li>Content that infringes on someone else's rights.</li>
      </ul>
      <p>We may remove or restrict access to any content that violates these rules.</p>

      <h2>5. Third-party services</h2>
      <p>Our Services may include ads, analytics, or features from third parties. Your use of these is subject to their own terms and privacy policies. We aren't responsible for third-party content or services.</p>

      <h2>6. Intellectual property</h2>
      <p>All rights, titles, and interests in our Services (games, artwork, logos, code, and designs) belong to Zero Immersive Inc or our licensors. You may not copy or distribute our content without permission.</p>

      <h2>7. Disclaimer and limitation of liability</h2>
      <ul>
        <li>The Services are provided "as is" without warranties of any kind.</li>
        <li>We don't guarantee uninterrupted or error-free service.</li>
        <li>To the fullest extent permitted by law, we aren't responsible for damages arising from your use of the Services.</li>
      </ul>

      <h2>8. Termination</h2>
      <p>We may suspend or terminate your access to the Services at any time if you violate these Terms. Upon termination, your rights to use the Services and any virtual items are revoked.</p>

      <h2>9. Dispute resolution</h2>
      <p>These Terms are governed by the laws of your country of residence unless otherwise required. Any disputes will be resolved through binding arbitration, unless prohibited by law.</p>

      <h2>10. Changes to these Terms</h2>
      <p>We may update these Terms from time to time. Updates will be posted here with a new effective date. Continued use of the Services means you accept the new Terms.</p>

      <h2>11. Contact us</h2>
      <p>If you have any questions about these Terms, please contact us:</p>
      <ul>
        <li>Email: <a href="mailto:accounts@zeroimmersive.com">accounts@zeroimmersive.com</a></li>
        <li>Phone: <a href="tel:+16475104511">+1 (647) 510-4511</a></li>
        <li>Location: Mississauga, Ontario, Canada</li>
      </ul>
      <p>Zero Immersive Inc</p>
    </LegalPage>
  );
}
